import { units, breakpoints } from '@ui/css';
import { isPlatformNodeJS } from '@utils/common';
import { makeScaleableToken, combineTokens } from '@utils/css';

const EXPANDED_BREADCRUMB_HEIGHT_PX = 50;
const expandedBreadcrumbHeight = makeScaleableToken(
  "--breadcrumb-expanded--height",
  units.px(EXPANDED_BREADCRUMB_HEIGHT_PX)
);
const COLLAPSED_BREADCRUMB_HEIGHT_PX = 0;
const collapsedBreadcrumbHeight = makeScaleableToken(
  "--breadcrumb-collapsed--height",
  units.px(COLLAPSED_BREADCRUMB_HEIGHT_PX)
);
const breadcrumbs = combineTokens("--breadcrumbs", {
  expanded: [expandedBreadcrumbHeight(), makeScaleableToken],
  collapsed: [collapsedBreadcrumbHeight(), makeScaleableToken],
  computed: collapsedBreadcrumbHeight
});
const EXPANDED_HEADER_HEIGHT_PX = 110;
const expandedHeaderHeight = makeScaleableToken(
  "--header-expanded--height",
  units.px(EXPANDED_HEADER_HEIGHT_PX)
);
const COLLAPSED_HEADER_HEIGHT_PX = 50;
const collapsedHeaderHeight = makeScaleableToken(
  "--header-collapsed--height",
  units.px(COLLAPSED_HEADER_HEIGHT_PX)
);
const height = combineTokens("--header", {
  expanded: [expandedHeaderHeight(), makeScaleableToken],
  collapsed: [collapsedHeaderHeight(), makeScaleableToken],
  computed: [
    `calc(${expandedHeaderHeight()} + ${breadcrumbs.computed()})`,
    makeScaleableToken
  ]
});
function getCurrentHeight(args) {
  var _a;
  const isMobile = isPlatformNodeJS() ? false : (_a = window.matchMedia) == null ? void 0 : _a.call(window, breakpoints.mobile.toQuery());
  const withBreadcrumb = document.documentElement.classList.contains("withBreadcrumb");
  return !isMobile ? 0 : (args == null ? void 0 : args.forceCollapsed) ? COLLAPSED_HEADER_HEIGHT_PX : EXPANDED_HEADER_HEIGHT_PX + (withBreadcrumb ? EXPANDED_BREADCRUMB_HEIGHT_PX : COLLAPSED_BREADCRUMB_HEIGHT_PX);
}

export { breadcrumbs, getCurrentHeight, height };
//# sourceMappingURL=header.js.map
